import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'social-starters',
		path: '/start-a-petition/social/:token',
		component: loadable(async () => import(/* webpackChunkName: "pages/social-starters" */ './index'), {
			exportName: 'SocialStarters',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
